import { render, staticRenderFns } from "./SearchContentHeader.vue?vue&type=template&id=b4552f82&scoped=true"
import script from "./SearchContentHeader.vue?vue&type=script&lang=js"
export * from "./SearchContentHeader.vue?vue&type=script&lang=js"
import style0 from "./SearchContentHeader.vue?vue&type=style&index=0&id=b4552f82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4552f82",
  null
  
)

export default component.exports